module.exports = __webpack_public_path__ + "img/symbol_4.a453a5f2.png";